module.exports = __webpack_public_path__ + "static/media/mh.c1782cea.svg";